// src/utils/tracking.js
//
// Consent gate for tracking calls fired from Vue components: gtag() events
// and the Floodlight/DoubleClick conversion pixels each quote-funnel step
// injects via document.body innerHTML. Those call sites previously fired
// unconditionally (gated only by a build-time env flag), with no runtime
// check against the user's cookie consent or GPC signal — components now
// guard their own pixel injection with canUseAdvertising() and route gtag
// calls through safeGtag() so both respect src/store/modules/consent.js.
//
// Must be wired once via bindTrackingStore(store) in main.js, mirroring
// src/utils/storage.js's bindToStore().

let _store = null;

export function bindTrackingStore(store) {
  _store = store;
}

function canUse(category) {
  if (!_store) return false;
  return _store.getters['consent/canUse'](category) === true;
}

export function canUseAdvertising() {
  return canUse('advertising');
}

// Gated wrapper for the global gtag() function. `category` should be
// 'analytics' for GA page/config events and 'advertising' for Floodlight
// conversion/purchase events. No-ops if gtag hasn't been loaded yet
// (analytics consent not granted) or if the relevant category isn't
// consented to.
export function safeGtag(category, ...args) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  if (!canUse(category)) return;
  window.gtag(...args);
}
